
import MemberService from "../services/member.service";
import { getMerchantCode } from "@/config/utils";

const checkMemberPermissions = async (to, from, next) => {
  const { meta, name } = to;
  const isActive = meta && meta.active !== undefined ? meta.active : true;

  if (isActive) {
    try {
      let listRouteCheck = [
        'Top-up',
        'Donation',
        'Transactions',
        'My Rewards',
        'My Campaigns',
        'Reward Catelogue',
        'Invite Friends',
        'Find Branches',
        'Contact Us',
        'FAQ',
        'Store',
      ];
      // routes gated by another route's permission (Store is a Rewards tab next to the Catalogue)
      const routePermission = {
        'Store': 'Reward Catelogue',
      };

      let merchantCode = getMerchantCode();
      merchantCode = merchantCode ? `/${merchantCode}` : "";

      if (listRouteCheck.includes(name)) {
        const response = await MemberService.checkMemberPermissions();
        let memberPermissions = response.data.data;

        if (memberPermissions.includes(routePermission[name] ?? name)) {
          const response2 = await MemberService.checkProfile();
          let profilePass = response2.data.data;

          if (profilePass) {
            next(true);
          } else {
            next(merchantCode + '/profile');
          }
        } else if (from.matched.length) {
          next(false);
        } else {
          // opened by URL: there is no page to stay on, so aborting would leave a blank screen
          next(merchantCode + '/home');
        }
      } else {
        const response2 = await MemberService.checkProfile();
        let profilePass = response2.data.data;

        if (profilePass) {
          next(true);
        } else {
          next(merchantCode + '/profile');
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
};

export default checkMemberPermissions;
